import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["day"]

  connect() {
    console.log("WeekdayController connected")
    this.dayTarget.textContent = new Date().toLocaleDateString(undefined, { weekday: "long" }).toLowerCase()
  }

  disconnect() {
    // this.dayTarget.textContent = ""
  }
}
